import React, { useState } from "react";

const tabs = [
  { key: "tab1", label: "Sub Wise" },
  { key: "tab2", label: "Strategy Wise" },
];

const Compare = ({ compareData, compareSubWiseData,compareStrategyWiseData }) => {
  const [activeTab, setActiveTab] = useState("tab1");
  const data = [
    {
      label: "Correct",
      color: "bg-green-600",
      compareData: [
        { name: "You", value: compareData?.you?.correct },
        { name: "other", value: compareData?.others?.correct },
        { name: "Toppers", value: compareData?.toppers?.correct },
      ],
    },
    {
      label: "InCorrect",
      color: "bg-[#124699]",
      compareData: [
        { name: "You", value: compareData?.you?.incorrect },
        { name: "other", value: compareData?.others?.incorrect },
        { name: "Toppers", value: compareData?.toppers?.incorrect },
      ],
    },
    {
      label: "Skip",
      color: "bg-yellow-600",
      compareData: [
        { name: "You", value: compareData?.you?.skipped },
        { name: "other", value: compareData?.others?.skipped },
        { name: "Toppers", value: compareData?.toppers?.skipped },
      ],
    },
    {
      label: "Accuracy",
      color: "bg-purple-600",
      compareData: [
        { name: "You", value: compareData?.you?.accuracy },
        { name: "other", value: compareData?.others?.accuracy },
        { name: "Toppers", value: compareData?.toppers?.accuracy },
      ],
    },
  ];
  const subTopicData = [];

  Object.entries(compareSubWiseData)?.forEach(([_, subtopic]) => {
    const subtopicName = subtopic?.subtopicName;
    const youAccuracy = subtopic?.you?.accuracy;
    const othersAccuracy = subtopic?.others?.accuracy;
    const toppersAccuracy = subtopic?.toppers?.accuracy;
    const progressData = [
      { label: "You", percentage: youAccuracy, color: "bg-green-600" },
      { label: "Other", percentage: othersAccuracy, color: "bg-[#124699]" },
      { label: "Topper", percentage: toppersAccuracy, color: "bg-purple-600" },
    ];
    subTopicData.push({
      name: subtopicName,
      progressData: progressData,
    });
  });
  const compareStrategyData = [
    { "name": "100% Sure", key: "100%Sure", progressData: [] },
    { "name": "Logic Play", key: "logicPlay", progressData: [] },
    { "name": "Intuition Hit Play", key: "intuitionHit", progressData: [] },
    { "name": "Blind Fire", key: "blindFire", progressData: [] },
    { "name": "50-50", key: "50-50", progressData: [] },
    { "name": "1-OPT Eliminate", key: "1-OPT Eliminate", progressData: [] },
    { "name": "Fear Driver Skip", key: "fearDriverSkip", progressData: [] },
    { "name": "Skip", key: "skip", progressData: [] }
];

compareStrategyData.forEach(item => {
    const key = item.key;
    if (compareStrategyWiseData[key]) {
      item.progressData = [
          {
              label: "You",
              percentage: compareStrategyWiseData[key]?.you?.accuracy,
              color: "bg-green-600"
          },
          {
              label: "Other",
              percentage: compareStrategyWiseData[key]?.others?.accuracy,  
              color: "bg-[#124699]"
          },
          {
              label: "Topper",
              percentage: compareStrategyWiseData[key]?.toppers?.accuracy, 
              color: "bg-purple-600"
          }
      ];
  }
});


  return (
    <>
      <div className="grid grid-cols-2 gap-6">
        {data?.map((item, index) => {
          return (
            <div key={index}>
              <p className="text-md font-semibold">{item?.label}</p>
              <div
                className={`${item?.color} px-4 py-2 text-white rounded-md mt-1`}
              >
                <div className="grid grid-cols-3 gap-3">
                  {item?.compareData.map((category, idx) => (
                    <div key={idx} className="flex flex-col items-center">
                      <p>{category?.value}</p>
                      <p>{category?.name}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          );
        })}
      </div>
      <div className="flex flex-wrap gap-2 lg:gap-4 border-b mt-7">
        {tabs?.map((tab) => (
          <button
            key={tab?.key}
            onClick={() => setActiveTab(tab?.key)}
            className={`px-3 py-1 flex justify-center  font-semibold text-md items-center transition duration-300 ${
              activeTab === tab?.key
                ? " border-b-2 border-[#124699]"
                : " text-gray-700"
            }`}
          >
            {tab?.label}
          </button>
        ))}
      </div>
      <div className="mt-4">
        {activeTab === "tab1" && (
          <div className="grid md:grid-cols-2 grid-cols-1">
            {subTopicData?.map((data, index) => {
              return (
                <div className="w-full  p-4 rounded-md" key={index}>
                  <p className="text-lg font-semibold mb-2">{data?.name}</p>
                  {data?.progressData?.map((item, index) => (
                    <div key={index} className="mb-3">
                      <div className="flex justify-between items-center mb-1">
                        <p className="text-sm w-12">{item?.label}</p>
                        <div className="w-full bg-gray-300 rounded-full h-4 relative mx-2">
                          <div
                            className={`${item?.color} h-4 rounded-full`}
                            style={{ width: `${item?.percentage}%` }}
                          ></div>
                        </div>
                        <p className="text-sm w-10 text-right">
                          {item?.percentage}%
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              );
            })}
          </div>
        )}
        {activeTab === "tab2" && (
          <div className="grid md:grid-cols-2 grid-cols-1">
            {compareStrategyData?.map((data, index) => {
              return (
                <div className="w-full  p-4 rounded-md" key={index}>
                  <p className="text-lg font-semibold mb-2">{data.name}</p>
                  {data?.progressData?.map((item, index) => (
                    <div key={index} className="mb-3">
                      <div className="flex justify-between items-center mb-1">
                        <p className="text-sm w-12">{item?.label}</p>
                        <div className="w-full bg-gray-300 rounded-full h-4 relative mx-2">
                          <div
                            className={`${item?.color} h-4 rounded-full`}
                            style={{ width: `${item?.percentage}%` }}
                          ></div>
                        </div>
                        <p className="text-sm w-10 text-right">
                          {item?.percentage}%
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </>
  );
};

export default Compare;
